<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>海洋溫差發電</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <div class="sectTit">全球首座MW 級海洋溫差發電基地在和平</div>
        <br>
        <div class="left">          
          <div>台灣是面積不大的海島國家，受限於自然資源及土地面積在發展再生能源方面有著不小的先天劣勢，目前國內再生能源以太陽光電和風力為主，但這兩者皆是「看天吃飯」的發電模式，太陽光電僅能白天發電且每逢雨天就無法發電，而適合風力發電的風況則多出現在冬季，對於缺電最嚴重的夏季幫助有限，綠電的來源需要多元、穩定、分散才是台灣發展綠能的長期解方。</div>
          <p>台泥企業團是目前國內投入再生能源項目最廣的企業，旗下台泥綠能擁有光電、陸域風機、漁電共生、地熱發電等案場，目前正攜手和平電力規劃在電廠所在的區域展開全球第一個 MW 級的海洋溫差發電基地，希望為四面環海的台灣找到 24 小時綠色基載電力的新機會。</p>
        </div>
        <div class="right">
          <img src="../../assets/otec/pic1_01.png" />
        </div>
        <div class="clear"></div>
        <div class="gallery">
          <div class="left">
            <div class="imgContainer1-1"></div>
            <div class="imgContainer1-2"></div>
          </div>
          <div class="right">
            <div class="imgContainer1-3"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="sectTit">何謂海洋溫差發電?</div>
        <p>地球面積 70% 為海洋所覆蓋，「海洋能」是目前備受關注的再生能源之一，海洋能源有洋流發電、潮汐發電、波浪發電及溫差發電，其中溫差發電適合於中、低緯度溫暖的表層海水帶。</p>
        <p>地球上最大的能量來源為太陽的輻射，而吸收太陽輻射最大的載體就是大海，表層海水經過太陽日照而升溫，而深層海水因陽光無法透入而維持穩定的冰冷低溫。</p>
        <div class="contOver">
        <img src="../../assets/otec/pic2_01.png" />
        </div>
        <p>海洋溫差發電（英語：Ocean Thermal Energy Conversion, OTEC）主要是透過海洋表層的「溫」海水與海洋深層的「冷」海水進行「熱交換」，達到「熱能」轉換成「電能」的效果。</p>
        <p>相較於太陽能與風電等其他綠色能源有間歇性的情況，海洋溫差發電可 24 小時運用，被視為可靠的基載電力來源。</p>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <div class="sectTit">和平電力發展海洋溫差發電優勢</div>
        <p>海洋溫差發電的關鍵是如何能容易取得深層的海水，台灣東部海域擁有獨特且特殊的海溝地形，和平電廠位於花蓮，向外海 1.6 公里處就可達到水深 600 公尺的深度，對於深層海水取水有相當大的優勢，偵測水溫約 7℃。</p>
        <p>表層海水水溫依照季節大約 25-29℃，目前溫差發電機組的設計是與和平電廠結合在一起，這也是一項優勢，因為平時電廠運作就會需要取用海水做為蒸汽餘熱降溫的未接觸冷卻用水來使用，這些水使用過後，溫度又會比表層海水溫度高 5-6 度，如此一來利用溫差能發電的效率就更加提高。</p>
        <div class="left">
          <p>若建設完成後將會是台灣首座大型海洋溫差發電系統也是世界第一座 MW 級商業運轉的海洋溫差發電廠，預估每部機組每天可穩定發電 2.4 萬度，約可供給超過 2,000 個小家庭的用電量。</p>
          <p>目前水下文化資產已經完成調查，環境影響評估 (EIA) 作業進行中，預計第一階段設計裝置容量 1-2 MW，目標 2028 年完成併網。</p>
        </div>
        <div class="right">
          <div class="txt">世界第一座商業運轉 MW 級<br>海洋溫差發電系統</div>
          <img src="../../assets/otec/pic3_01.png" />
          <br>
          <div class="day">穩定發電 / 日</div>
          <div ref="runData">
            <span class="num1">24000</span> 度
            <span class="arrow">
              <div class="stick">供給</div>
              <div class="tri"></div>
            </span>
            <span class="num2">2000</span> 戶
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </section>
    <section class="sect4">
      <div class="ctx">
        <div class="sectTit">和平電力團隊訪察久米島 OTEC 示範電廠</div>
        <swiper
          :modules = "modules"
          :slides-per-view="1"
          :space-between="1"
          :autoplay="{delay:3000, disableOnInteraction:false}"
          :speed="1000"
          :loop="true"
          :pagination="{clickable:true}"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          class="swiper"
        >
          <swiper-slide class="cover cover1"></swiper-slide>
          <swiper-slide class="cover cover2"></swiper-slide>
          <swiper-slide class="cover cover3"></swiper-slide>
          <swiper-slide class="cover cover4"></swiper-slide>
          <swiper-slide class="cover cover5"></swiper-slide>
        </swiper>
      </div>
    </section>
    <section class="sect5">
      <div class="ctx">
        <div class="sectTit">國際海洋溫差發電技術發展</div>
        <p>1973 年世界第一次能源危機發生掀起大規模研究海洋溫差發電熱潮，但隨著能源危機的解除而中斷，後來美、日兩國 2007 年開始重新啟動 OTEC 技術研發並以商業運轉模組為開發目標，其中美國 Lockheed Martin 公司結合 Makai 工程公司，於 2008 年在夏威夷規劃 100MW 商業型電廠建置計畫，2009 年更獲得美國海軍資助進行 OTEC 可行性計畫，評估於夏威夷、關島、波多黎各、琉球、Diego Carcia 等建廠研究，推動至今 Makai 公司已於 2015 年在夏威夷 NELHA 園區完成可供應 105kW 的 OTEC 電廠建置（深層海水日取水量 16 萬噸），現今更銜接當地電網，供應約 200 戶家庭使用。</p>
        <p>另外，日本以佐賀大學為主的研發團隊則在 1980 年代開始投入 OTEC 相關技術研發，對於熱交換器及新型發電系統著墨最多引領相關技術推動，2013 年佐賀大學結合 Xenesys 公司、IHI 工程建設公司及河電機公司於久米島完成建置 2 座 50kW 之 OTEC 示範電廠並實施連續運轉試驗至今，和平電力公司團隊在 2022 年時也到了日本久米島進行訪察，思考的是怎麼把這些經驗帶回台灣、如何讓發電規模更大更穩定。</p>
        <p>目前日本與美國的兩個電廠都已具有商業化規模與超過 10 年長期運轉的實績，只是都還是 kW 級的海洋溫差電廠，而和平電力是預計投入 MW 級的海洋溫差能的開發。</p>
      </div>
    </section>
    <section class="sect6">
      <div class="ctx">
        <div class="sectTit">國際海洋溫差發電歷程</div>
        <div class="history">
          <div class="item" v-for="(row, idx) in otecHistory" :key="idx">
            <div class="year">{{row.year}} 年</div>
            <div class="dash"></div>
            <div class="desp">{{row.desp}}</div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect7">
      <div class="ctx">
        <div class="sectTit">未來和平電廠海洋深層水 關聯產業</div>
        <div class="industry">
          <div class="item" v-for="(row, idx) in industry" :key="idx">
            <img class="icon" :src="setIndustryIcon(row.icon)" />
            <div class="tit">{{row.tit}}</div>
            <div class="desp" v-html="row.desp"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect8">
      <br>
      <div class="ctx">
        <div class="sectTit">海洋溫差發電的附加價值</div>        
        <p>海洋溫差發電後的深層水依然擁有其高營養鹽、乾淨的特點，以日本久米島海洋溫差發電設施來看，當中深層海水日取水量 1.3 萬噸，深層海水可應用於龍膽石斑魚等高經濟水產養殖、SPA 水療觀光、富含礦物質的海洋深層飲用水等延伸產業。</p>
        <p>另台灣東海岸深層海水的溶解鹽類大約是表層的 15 倍以上，此種高濃度的營養鹽類有助於海水養殖、製藥或生物科技的發展，冷海水的冷度可用於空調、冷藏或農業生產等區域供冷等需求。</p>
        <p>以國外經驗來看，產業應用層面相當廣泛，待運行成效穩定後，這些都可作為未來在地深層水發展潛力的參考。</p>
        <div class="gallery">
          <div class="left">
            <div class="imgContainer8-1">
              <div class="imgTit">海洋深層水蔬菜種植</div>
            </div>
          </div>
          <div class="right">
            <div class="imgContainer8-2">
              <div class="imgTit">海洋深層水養殖</div>
            </div>
          </div>
        </div>
      </div>
      <br>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Util, ImgContainerAutoResize, NumRun } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default defineComponent({
  name: 'Otec',
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide
  },
  setup() {
    const onSwiper = (swiper: any) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay]
    };
  },
  data() {
    return {
      runDataBoundingBottom: 0,
      runDataHeight: 0,
      isShowNum: false,
      otecHistory: [
        {year: "1973", desp: "第一次能源危機開始大規模研究海洋溫差發電"},
        {year: "1980", desp: "日本佐賀大學研發團隊開始投入 OTEC 相關技術研發"},
        {year: "2007", desp: "美、日二國以商業運轉模組為開發目標，重啟 OTEC 技術"},
        {year: "2008", desp: "美國在夏威夷規劃 100MW 商業型電廠建置計畫"},
        {year: "2009", desp: "美國獲得海軍資助於夏威夷、關島、波多黎各、琉球、Diego Carcia 等處建廠"},
        {year: "2013", desp: "日本佐賀大學結合業界公司於久米島建置 2 座 50kW 的 OTEC 示範電廠"},
        {year: "2015", desp: "夏威夷 NELHA 園區完成可供應 105kW 的 OTEC 電廠建置"},
        {year: "2022", desp: "台灣和平電力公司團隊至日本久米島訪察　預計投入 MW 級海洋溫差發電"}
      ],
      industry: [
        {
          tit: "富含礦物質",
          desp: "海洋深層飲用水",
          icon: "icon7_01.png"
        },
        {
          tit: "分子細緻",
          desp: "美容保養品<br>SPA 水療觀光",
          icon: "icon7_02.png"
        },
        {
          tit: "高營養",
          desp: "養殖高價值水產<br>白蝦/龍膽石斑",
          icon: "icon7_03.png"
        },
        {
          tit: "穩定低溫",
          desp: "平地種高山蔬果",
          icon: "icon7_04.png"
        }
      ]
    }
  },
  methods:{
    showNum: function() {
      new NumRun(document.querySelector(".num1") as HTMLElement, 600);
      new NumRun(document.querySelector(".num2") as HTMLElement, 600);
    },
    chkShowNum: function() {
      let _this = this;
      this.runDataBoundingBottom = (this.$refs.runData as HTMLElement).getBoundingClientRect().bottom;
      this.runDataHeight = (this.$refs.runData as HTMLElement).offsetHeight;

      if( Util.getDomHeight() > (_this.runDataBoundingBottom + 50)) {
        if(!_this.isShowNum) {          
          _this.isShowNum = true;
          _this.showNum();
        }
      }

      // if( window.scrollY + Util.getDomHeight() > _this.coralOffsetTop ) {
      // }

      // if( window.scrollY + Util.getDomHeight() > _this.coralOffsetTop + _this.coralHeight) {
      // }
    },
    setIndustryIcon: function(file: string) {
      return require(`@/assets/otec/${file}`);
    }
  },
  mounted() {
    setTimeout( () => {
      this.chkShowNum();
    }, 100);

    window.addEventListener("scroll", () => {
      this.chkShowNum();
    });

    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-1") as HTMLElement, 0.445);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-2") as HTMLElement, 0.445);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-3") as HTMLElement, 0.9);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover1") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover2") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover3") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover4") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover5") as HTMLElement, 0.55);
    // new ImgContainerAutoResize(document.querySelector(".sect8 .ctx") as HTMLElement, 0.68);
    new ImgContainerAutoResize(document.querySelector(".imgContainer8-1") as HTMLElement, 0.60);
    new ImgContainerAutoResize(document.querySelector(".imgContainer8-2") as HTMLElement, 0.60);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/otec/kv.webp");
  background-position: center 75%;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 {
  background: #F4F3F3;
}

.sect1 .ctx {
  padding: 40px 0 100px;
}

.sect1 .sectTit {
  margin: 0 0 30px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect1 .left {
  width: 80%;
  float: left;
  line-height: 2em;
}

.sect1 .right {
  width: 15%;
  float: right;
}

.sect1 .right img {
  width: 100%;
}

.sect1 .gallery {
  margin: 40px 0 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: 30px;  
}

.sect1 .gallery .left {
  flex: 0 0 49.7%;
}

.sect1 .gallery .left .imgContainer1-1 {
  background: url(../../assets/otec/pic1_02.jpg) center no-repeat;
  background-repeat: no-repeat;
}

.sect1 .gallery .left .imgContainer1-2 {
  margin: 1% 0 0;
  background: url(../../assets/otec/pic1_03.jpg) center no-repeat;
  background-size: cover;
}

.sect1 .gallery .right {
  flex: 0 0 49.7%;
}

.sect1 .gallery .right .imgContainer1-3 {
  background: url(../../assets/otec/pic1_04.jpg) center no-repeat;
  background-size: cover;
}

.sect2 {
  /* background: #85AECC; */
  /* background: radial-gradient(circle at 50% 25%, #FDF8E4, #FDF8E4 70%, #ffffff00 70.1%); */
  background: radial-gradient(circle at 50% 50%, #fff 75%, #ffffff00 75.1%), url(../../assets/otec/sectBack2.jpg) center no-repeat;
  background-size: cover, cover;
}

.sect2 p {
  letter-spacing: 1px;
  line-height: 2em;
  color: #0C5F99;
}

.sect2 img {
  width: 1200px;
}

.sect2 .sectTit {
  width: 450px;
  margin: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  color: #fff;
  background: #85AECC;
}

.sect3 {
  background: #F4F3F3;
}

.sect3 .sectTit {
  margin: 0 0 20px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect3 p {
  margin: 0;
  padding: 0 0 20px;
  letter-spacing: 1px;
  line-height: 2em;
}

.sect3 .left {
  width: 50%;
  float: left;
}

.sect3 .right {
  width: 45%;
  padding: 20px 30px 10px;
  box-sizing: border-box;
  float: right;
  border-radius: 30px;
  background: #fff;
}

.sect3 .right .txt {
  font-size: 24px;
  color: #63BFAA;
}

.sect3 .right img {
  margin: -70px 0 0 45%;
  display: inline-block;
  width: 55%;
}

.sect3 .right .day {
  /* margin: 10px 0 0; */
  padding: 3px 20px 5px;
  box-sizing: border-box;
  display: inline-block;
  border-radius: 20px;
  color: #fff;
  background: #E8967A;
}

.sect3 .right .arrow {
  height: 40px;
  margin: auto 15px;
  display: inline-flex;
  align-items: center;
  /* background: #40404022; */
  transform: translateY(-10px);
}

.sect3 .right .arrow .stick {  
  flex: 1 0 auto;
  height: 27px;
  padding: 0 0 0 10px;
  color: #fff;
  background: #f2c400;
}

.sect3 .right .arrow .tri {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 20px 0 20px 20px;
  border-color: transparent transparent transparent #f2c400;  
}

.sect3 .right .num1,
.sect3 .right .num2 {
  font-family: arial;
  font-weight: 900;
  font-size: 48px;
  color: #095F99;
  opacity: 0;
}

.sect4 {
  background: #63BFAA;
}

.sect4 .sectTit {
  margin: 0 0 20px;
  letter-spacing: 3px;
  text-align: center;
  font-size: 36px;
  color: #fff;
}

.sect4 .swiper {
  border-radius: 20px;
}

.sect4 .swiper .swiper-wrapper {
  /* overflow: hidden; */
}

.sect4 .swiper .cover1 {
    background: url(../../assets/otec/carousel4_01.webp) center;
    background-size: cover;
}

.sect4 .swiper .cover2 {
    background: url(../../assets/otec/carousel4_02.webp) center;
    background-size: cover;
}

.sect4 .swiper .cover3 {
    background: url(../../assets/otec/carousel4_03.webp) center;
    background-size: cover;
}

.sect4 .swiper .cover4 {
    background: url(../../assets/otec/carousel4_04.webp) center;
    background-size: cover;
}

.sect4 .swiper .cover5 {
    background: url(../../assets/otec/carousel4_05.webp) center;
    background-size: cover;
}

.sect4 .swiper .swiper-pagination {
  /* bottom: -40px !important; */
}

.sect4 .swiper .swiper-pagination .swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  border: solid 1px #fff;
  background: #404040;
  opacity: 0.8;
}

.sect4 .swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #fff;
}

.sect5 {
  background: #F4F3F3;
}

.sect5 .sectTit {
  margin: 0 0 20px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect5 p {
  margin: 0;
  padding: 0 0 20px;
  letter-spacing: 1px;
  line-height: 2em;
}

.sect6 {
  /* background: #85AECC; */
  background: url(../../assets/otec/sectBack6.jpg) center no-repeat;
  background-size: cover;
}

.sect6 .ctx {
  padding: 60px 0 100px;
}

.sect6 .sectTit {
  width: 500px;
  margin: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  background: #E6E2E1;
}

.sect6 .history {
  margin: 20px 0;
}

.sect6 .history .item {
  margin: 0 0 15px;
  display: flex;
  align-items: center;
}

.sect6 .history .item .year {
  padding: 10px 25px;
  box-sizing: border-box;
  border-radius: 30px;
  font-weight: bold;
  color: #0C5F99;
  background: #FCF2CB;
}

.sect6 .history .item .dash {
  flex: 0 0 30px;
  height: 5px;
  background: #FCF2CB;
}

.sect6 .history .item .desp {
  flex: 1 0 auto;
  padding: 10px 25px;
  box-sizing: border-box;
  border-radius: 30px;
  letter-spacing: 1px;
  background: #FCF2CB;
}

.sect6 .history .item:nth-child(odd) .year {
  background: #FFF;
}

.sect6 .history .item:nth-child(odd) .dash {
  background: #FFF;
}

.sect6 .history .item:nth-child(odd) .desp {
  background: #FFF;
}

.sect7 {
  background: url(../../assets/otec/sectBack7.jpg) center no-repeat;
  background-size: cover;
}

.sect7 .sectTit {
  width: 700px;
  margin: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  color: #fff;
  background: #63BFAA;
}

.sect7 .industry {
  margin: 40px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.sect7 .industry .item {
  flex: 0 0 280px;
  height: 280px;
  padding: 25px;
  box-sizing: border-box;
  border-radius: 100%;
  text-align: center;
  background: #fff;
}

.sect7 .industry .item .icon {
  height: 120px;
}

.sect7 .industry .item .tit {
  margin: 10px 0 0;
  font-weight: bold;
  font-size: 28px;
  color: #0C5F99;
}

.sect8 {
  background: #F4F3F3;
}

.sect8 .ctx {
  margin: 50px auto 100px;
  padding: 60px 40px 0;
  box-sizing: border-box;
  border-radius: 30px;
  background: url(../../assets/otec/map8_01.jpg) center top no-repeat;
  background-size: cover;
}

.sect8 .sectTit {
  margin: 0 0 10px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect8 p {
  width: 50%;
  letter-spacing: 1px;
  line-height: 2em;
}

.sect8 .gallery {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  transform: translateY(60px);
}

.sect8 .gallery .left,
.sect8 .gallery .right {
  flex: 0 0 48.5%;
  box-sizing: border-box;
  position: relative;
  border-radius: 30px;
  border: solid 7px #fff;
  overflow: hidden;
}

.sect8 .gallery .left .imgContainer8-1 {
  background: url(../../assets/otec/pic8_01.jpg) center no-repeat;
  background-size: cover;
}

.sect8 .gallery .right .imgContainer8-2 {
  background: url(../../assets/otec/pic8_02.jpg) center no-repeat;
  background-size: cover;
}

.sect8 .gallery .left .imgTit,
.sect8 .gallery .right .imgTit {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  text-align: center;
  color: #fff;
  background: #00000066;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }

  .sect2 {
    background: radial-gradient(circle at 50% 50%, #fff 82%, #ffffff00 82.1%), url(../../assets/otec/sectBack2.jpg) center no-repeat;
    background-size: cover, cover;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }

  .sect2 {
    background: radial-gradient(circle at 50% 50%, #fff 90%, #ffffff00 90.1%), url(../../assets/otec/sectBack2.jpg) center no-repeat;
    background-size: cover, cover;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect1 .ctx {
    padding: 40px 40px 100px;
  }

  .sect2 {
    background: radial-gradient(circle at 50% 50%, #ffffffaa 100%, #ffffffaa 100.1%), url(../../assets/otec/sectBack2.jpg) center no-repeat;
    background-size: cover, cover;
  }

  .sect3 .left {
    width: 100%;
  }

  .sect3 .right {
    width: 100%;
  }

  .sect6 .ctx {
    padding: 40px 20px 60px;
  }

  .sect6 .sectTit {
    width: 320px;
    font-size: 24px;
    top: -30px;
  }

  .sect6 .history .item .year {
    flex: 0 0 90px;
    padding: 5px 10px;
    border-radius: 15px;
    text-align: center;
  }

  .sect6 .history .item .dash {
    flex: 0 0 20px;
  }

  .sect6 .history .item .desp {
    flex: 1 1 auto;
    padding: 10px 15px;
    border-radius: 15px;
  }

  .sect7 .industry {
    width: 650px;
    margin: 40px auto 20px;
  }

  .sect7 .industry .item {
    margin: 20px 0;
  }

  .sect8 .ctx {
    width: 95%;
    margin: 0 2.5% 100px;
  }

  .sect8 p {
    width: 65%;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect1 .ctx {
    padding: 40px 20px 60px;
  }

  .sect1 .left {
    width: 100%;
  }

  .sect1 .right {
    width: 100%;
  }

  .sect1 .right img {
    width: 40%;
    margin: 0 30%;
  }

  .sect1 .gallery {
    margin: 20px 0 0;
  }

  .sect1 .gallery .left {
    flex: 0 0 100%;
  }

  .sect1 .gallery .left .imgContainer1-2 {
    margin: 5px 0;
  }

  .sect1 .gallery .right {
    flex: 0 0 100%;
  }

  .sect2 {
    background: radial-gradient(circle at 50% 50%, #ffffff88 100%, #ffffff88 100.1%), url(../../assets/otec/sectBack2.jpg) center no-repeat;
    background-size: cover, cover;
  }

  .sect2 .sectTit {
    width: 280px;
    font-size: 24px;
    top: -30px;
  }

  .sect3 .left {
    width: 100%;
  }

  .sect3 .right {
    width: 100%;
    padding: 10px 15px 10px;
  }

  .sect3 .right .txt {
    font-size: 20px;
  }

  .sect3 .right img {
    margin: -10px 0 0;
    display: block;
    width: 100%;
  }

  .sect3 .right .day {
    margin: 0 0 10px;
  }

  .sect3 .right .arrow {
    margin: auto 5px;
    transform: translateY(0);
  }

  .sect3 .right .num1,
  .sect3 .right .num2 {
    font-size: 24px;
  }

  .sect4 .sectTit {
    font-size: 24px;
  }

  .sect6 .ctx {
    padding: 40px 20px 60px;
  }

  .sect6 .sectTit {
    width: 320px;
    font-size: 24px;
    top: -30px;
  }

  .sect6 .history .item .year {
    flex: 0 0 90px;
    padding: 5px 10px;
    border-radius: 15px;
    text-align: center;
  }

  .sect6 .history .item .dash {
    flex: 0 0 20px;
  }

  .sect6 .history .item .desp {
    flex: 1 1 auto;
    padding: 10px 15px;
    border-radius: 15px;
  }

  .sect7 .sectTit {
    width: 320px;
    top: -45px;
    font-size: 24px;
  }

  .sect7 .industry {
    margin: 20px 0;
  }

  .sect7 .industry .item {
    flex: 0 0 280px;
    height: 280px;
    margin: 10px auto;
  }

  .sect8 .ctx {
    margin: 0 auto;
    padding: 40px 20px;
    background: none;
  }

  .sect8 p {
    width: 100%;
  }

  .sect8 .gallery {
    margin: 20px 0 0;
    transform: translateY(0);
  }

  .sect8 .gallery .left,
  .sect8 .gallery .right {
    flex: 0 0 100%;
  }
}
</style>
